import orderApi from "@/api/order";
const order = {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    orderList({ commit }, data) {
      return orderApi.list(data);
    },
    cancelOrders({ commit }, data) {
      return orderApi.cancelOrders(data);
    },
    batchChangeOrderState({ commit }, data) {
      return orderApi.batchChangeOrderState(data);
    },
    batchImportMailNo({ commit }, data) {
      return orderApi.batchImportMailNo(data);
    },
    perviewImportMailNo({ commit }, data) {
      return orderApi.perviewMailNoImport(data);
    },
    exportOrderList({ commit }, data) {
      return orderApi.exportOrderList(data);
    },
    refundOrderList({ commit }, data) {
      return orderApi.refundOrderList(data);
    },
    refundOrderDetail({ commit }, data) {
      return orderApi.refundOrderDetail(data);
    },
    downloadRefundOrder({ commit }, data) {
      return orderApi.downloadRefundOrder(data);
    },
    createTicket({ commit }, data) {
      return orderApi.createTicket(data);
    },
    openPlatformOrderImport({ commit }, data) {
      return orderApi.openPlatformOrderImport(data);
    },
    importOrderData({ commit }, data) {
      return orderApi.importOrderData(data);
    },
  },
};

export default order;
